import { OperationStateChange } from '@/types';

export function setNewTotal(oldTotal: number | string, operationState: OperationStateChange) {
  if (operationState.type === "added") {
		if (typeof oldTotal === 'string') {
			return operationState.newOperation.amount;
		}

    return operationState.newOperation.type === "debit" ?
      oldTotal - operationState.newOperation.amount : oldTotal + operationState.newOperation.amount;
  }

	if (typeof oldTotal === 'number') {
		if (operationState.type === "deleted") {
			return operationState.newOperation.type === "debit" ?
				oldTotal + operationState.newOperation.amount : oldTotal - operationState.newOperation.amount;
		}

		if (operationState.type === "updated") {
			if (!operationState.fieldsTouched || !operationState.oldOperation?.amount) return oldTotal;

			if (!operationState.fieldsTouched.type && !operationState.fieldsTouched.hasOwnProperty("amount")) return oldTotal;

			if (operationState.fieldsTouched.amount) {
				if (!operationState.fieldsTouched.hasOwnProperty("type")) {
					const toAdd = (operationState.newOperation.amount - operationState.oldOperation.amount);
					return operationState.newOperation.type === "debit" ? oldTotal - toAdd : oldTotal + toAdd
				}
			}

			if (operationState.fieldsTouched.type) {
				const diff = operationState.newOperation.amount + operationState.oldOperation.amount;
				return operationState.newOperation.type === "debit" ? oldTotal - diff : oldTotal + diff;
			}
		}
	}
}
